interface ErrorMessageProps {
    message: string;
}

const ErrorMessage = ({ message }: ErrorMessageProps) => {
    return <p className='mt-1 w-full pl-4 text-sm text-destructive'>{message}</p>
}

export { ErrorMessage }
